import moveConversations from './moveConversations';
import moveItems from './moveItems';
import { listViewStore } from 'owa-mail-list-store';
import { action } from 'satcheljs/lib/legacy';
export default action('moveMailListRows')(function moveMailListRows(rowKeys, destinationFolderId, originalTableViewId, actionSource) {
    var originalTableView = listViewStore.tableViews.get(originalTableViewId);
    switch (originalTableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            moveConversations(rowKeys, destinationFolderId, originalTableView, actionSource);
            break;
        case 1 /* Message */:
            moveItems(rowKeys, destinationFolderId, originalTableView, actionSource);
            break;
    }
});
//# sourceMappingURL=moveMailListRows.js.map